import React from 'react';

const WasteManagementTab = ({ waste }) => {
  if (!waste || !waste.summary) {
    return (
      <div className="text-center py-4 text-muted">
        No waste data available
      </div>
    );
  }

  const { summary, idleInstances, stoppedInstances, unattachedVolumes, unusedEIPs, oldSnapshots } = waste;

  const wasteCategories = [
    { key: 'idle', label: 'Idle Instances', data: idleInstances },
    { key: 'stopped', label: 'Stopped Instances', data: stoppedInstances },
    { key: 'volumes', label: 'Unattached Volumes', data: unattachedVolumes },
    { key: 'eips', label: 'Unused Elastic IPs', data: unusedEIPs },
    { key: 'snapshots', label: 'Old Snapshots', data: oldSnapshots }
  ].filter(cat => cat.data?.count > 0);

  if (wasteCategories.length === 0) {
    return (
      <div className="text-center py-4 text-muted">
        No waste resources detected
      </div>
    );
  }

  return (
    <div>
      {wasteCategories.map(cat => (
        <div key={cat.key} className="card border-0 shadow-sm mb-3">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="mb-0">{cat.label}</h6>
              <span className="text-muted">{cat.data.count} resources</span>
            </div>
            {cat.data.items && cat.data.items.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-sm mb-0">
                  <thead>
                    <tr className="text-muted" style={{ fontSize: '0.875rem' }}>
                      {cat.key === 'idle' && (
                        <>
                          <th className="border-0 fw-normal">Instance</th>
                          <th className="border-0 fw-normal">Type</th>
                          <th className="border-0 fw-normal">Region</th>
                          <th className="border-0 fw-normal">Avg CPU</th>
                        </>
                      )}
                      {cat.key === 'stopped' && (
                        <>
                          <th className="border-0 fw-normal">Instance</th>
                          <th className="border-0 fw-normal">Type</th>
                          <th className="border-0 fw-normal">Region</th>
                          <th className="border-0 fw-normal">State</th>
                        </>
                      )}
                      {cat.key === 'volumes' && (
                        <>
                          <th className="border-0 fw-normal">Volume ID</th>
                          <th className="border-0 fw-normal">Size</th>
                          <th className="border-0 fw-normal">Type</th>
                          <th className="border-0 fw-normal">Region</th>
                        </>
                      )}
                      {cat.key === 'eips' && (
                        <>
                          <th className="border-0 fw-normal">IP Address</th>
                          <th className="border-0 fw-normal">Allocation ID</th>
                          <th className="border-0 fw-normal">Region</th>
                        </>
                      )}
                      {cat.key === 'snapshots' && (
                        <>
                          <th className="border-0 fw-normal">Snapshot ID</th>
                          <th className="border-0 fw-normal">Size</th>
                          <th className="border-0 fw-normal">Age</th>
                          <th className="border-0 fw-normal">Region</th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {cat.data.items.slice(0, 10).map((item, idx) => (
                      <tr key={idx}>
                        {cat.key === 'idle' && (
                          <>
                            <td><code className="text-muted">{item.name || item.id}</code></td>
                            <td>{item.type}</td>
                            <td>{item.region}</td>
                            <td>{item.avgCPU?.toFixed(1)}%</td>
                          </>
                        )}
                        {cat.key === 'stopped' && (
                          <>
                            <td><code className="text-muted">{item.name || item.id}</code></td>
                            <td>{item.type}</td>
                            <td>{item.region}</td>
                            <td>Stopped</td>
                          </>
                        )}
                        {cat.key === 'volumes' && (
                          <>
                            <td><code className="text-muted">{item.id}</code></td>
                            <td>{item.size} GB</td>
                            <td>{item.type}</td>
                            <td>{item.region}</td>
                          </>
                        )}
                        {cat.key === 'eips' && (
                          <>
                            <td><code className="text-muted">{item.ip}</code></td>
                            <td><code className="text-muted">{item.allocationId}</code></td>
                            <td>{item.region}</td>
                          </>
                        )}
                        {cat.key === 'snapshots' && (
                          <>
                            <td><code className="text-muted">{item.id}</code></td>
                            <td>{item.size} GB</td>
                            <td>{item.age} days</td>
                            <td>{item.region}</td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-muted mb-0">Select an account to view resource details</p>
            )}
            {cat.data.items && cat.data.items.length > 10 && (
              <div className="mt-2 text-muted" style={{ fontSize: '0.875rem' }}>
                Showing 10 of {cat.data.items.length} resources
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default WasteManagementTab;
